class Wiki {
  id: number;
  groupId: number;
  title: string = '';
  text: string = '';
  created: number;
  updated: number;
}

export default Wiki;



// WEBPACK FOOTER //
// ./src/entities/Wiki.ts